import React from 'react';

import { SEO } from 'main/components';

export const EUCyberSecurity: React.FC = () => {
  return (
    <>
      <SEO seoTitle="Cyber Security - Orqa" noindex={true} />
      <section className="projects">
        <header className="projects__header">
          <p className="t-zeta t-upperext  t-nowrap o-40 s-bottom--sml">
            EU Projects
          </p>
          <h1 className="t-beta t-primary t-center s-bottom--sml">
            Dijagnostika kibernetičke otpornosti tvrtke ORQA d.o.o.
          </h1>
          <p className="t-zeta t-center o-40 s-bottom--med">
            <span style={{ display: 'block' }}>VAUČERI ZA DIGITALIZACIJU</span>
            <span style={{ display: 'block' }}>
              (Referentni broj: NPOO.C1.1.2. R3-I2.02)
            </span>
          </p>
        </header>
        <div className="projects__sponsors">
          <img
            src={require('main/assets/images/eu-amblem.webp')}
            alt="ESIF logo"
            className="projects__sponsors__img__cybersecurity"
          />
        </div>
        <div className="wrapper wrapper--ultranarrow">
          <h5 className="s-bottom--med">Opis projekta:</h5>
          <p className="t-delta s-bottom--med">
            Provedbom provjere kibernetičke otpornosti informacijskog sustava
            web aplikacija tvrtke ORQA d.o.o, analizom dobivenih podataka,
            definiranjem poboljšanja sustava te provođenjem potrebnih radnji i
            edukacijom zaposlenika iz područja kibernetičke sigurnosti,
            omogućava se znatno veća razina otpornosti prijavitelja na
            kibernetičke napade, otuđenje intelektualnog vlasništva i ostale
            ugroze sličnog tipa, a posljedično tome otvaraju se mogućnosti za
            ostvarivanje suradnje sa klijentima koji zahtijevaju višu razinu
            otpornosti na kibernetičke prijetnje.
          </p>
          <p className="s-bottom--med">
            Ukupna vrijednost projekta: 25.025,37 EUR
          </p>
          <p className="s-bottom--med">
            Iznos bespovratnih sredstava – vrijednost vaučera: 14.014,21 EUR
          </p>
          <p className="s-bottom--med">
            Trajanje provedbe projekta: 19.06.2024. – 19.06.2025.
          </p>
          <p className="t-zeta o-60">
            Sadržaj je isključiva odgovornost tvrtke Orqa d.o.o. i ni pod kojim
            uvjetima ne odražava stav Europske unije.
          </p>
        </div>
      </section>
    </>
  );
};
